import * as Sentry from "@sentry/react";

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || "development";
  const appVersion = import.meta.env.VITE_APP_VERSION || "0.0.0";

  Sentry.init({
    dsn,
    environment,
    release: `hulahoop-landing@${appVersion}`,

    tracesSampleRate: 0.1,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
        maskAllInputs: true,
      }),
    ],

    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "top.GLOBALS",
      "canvas.contentDocument",
      "Network request failed",
      "Failed to fetch",
      "NetworkError",
      "Non-Error promise rejection captured",
      "AbortError",
      "The operation was aborted",
    ],

    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
  });
}
